module.exports = __webpack_public_path__ + "img/logoWithTitle.79ca2b84.svg";